<template>
    <Panel :id="feature['id']" class="detail-panel">
        <template v-slot:header>
            <Button
                size="large"
                @click="this.$emit('hideDetailPanel')"
                aria-label="Ga terug naar lijstweergave"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#000000"
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
                </svg>
            </Button>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#000000"
                class="expand-icon"
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
            </svg>
            <Button
                size="large"
                @click="this.$emit('hideDetailAndListPanel')"
                aria-label="Sluit detailweergave"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#000000"
                >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                </svg>
            </Button>
        </template>

        <div class="details">
            <h3>{{ feature['naam'] }}</h3>
            <div v-if="feature.highlighted" class="type">
                Voorrangsschool<img src="images/icon-school-preference.svg" aria-hidden="true" />
            </div>
            <div v-if="feature.stedelijke_school === 'Ja'" class="type">
                Stedelijke school<img src="images/icon-school-stedelijk.svg" aria-hidden="true" />
            </div>

            <div class="address">
                {{ feature['straat'] }} {{ feature['huisnr'] }}{{ feature['toevoeging'] }},
                {{ feature['plaats'] }}
            </div>

            <p v-if="feature['ukc_naam']">
                Kinderen op {{ feature['ukc_naam'] }} kunnen voorrang krijgen op deze school. Bekijk
                <a
                    href="https://naardebasisschool.utrecht.nl/stap-3-verdeling-van-de-plaatsen/#c412653"
                    target="_blank"
                    >de voorrangregels</a
                >.
            </p>

            <p v-if="feature['belangrijke_informatie']">
                <markdown :source="feature['belangrijke_informatie']" :inline="false" />
            </p>

            <p v-if="feature['peuteropvang_naam']">
                Kinderen op {{ feature['peuteropvang_naam'] }}
                <span v-if="feature['peuteropvang_naam2']"
                    >of {{ feature['peuteropvang_naam2'] }}</span
                >
                kunnen voorrang krijgen op deze school. Bekijk
                <a
                    href="https://naardebasisschool.utrecht.nl/stap-3-verdeling-van-de-plaatsen/#c412653"
                    target="_blank"
                    >de voorrangregels</a
                >.
            </p>
        </div>

        <div class="links">
            <a
                v-if="feature['website']"
                :href="feature['website']"
                target="_blank"
                v-tippy="{ placement: 'right', delay: 0 }"
                content="Bekijk"
                aria-label="Bekijk website (opent in nieuw venster)"
            >
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                {{ (feature['website'] || '').replace('https://', '') }}
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
            <button
                v-if="feature['email'] && !isMobile()"
                type="button"
                @click="copyEmail"
                v-tippy="{ placement: 'right', delay: 0 }"
                content="Kopieer"
                aria-label="Kopieer emailadres"
            >
                <svg
                    width="20px"
                    height="16px"
                    viewBox="0 0 20 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="mail_outline_black_24dp"
                            transform="translate(-2.000000, -4.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,18 L4,18 L4,8 L12,13 L20,8 L20,18 Z M12,11 L4,6 L20,6 L12,11 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                <span>{{ feature['email'] }}</span>
                <svg
                    width="15px"
                    height="18px"
                    viewBox="0 0 15 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="content_copy_black_18dp"
                            transform="translate(-1.000000, 0.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,0.75 L3,0.75 C2.175,0.75 1.5,1.425 1.5,2.25 L1.5,12.75 L3,12.75 L3,2.25 L12,2.25 L12,0.75 Z M14.25,3.75 L6,3.75 C5.175,3.75 4.5,4.425 4.5,5.25 L4.5,15.75 C4.5,16.575 5.175,17.25 6,17.25 L14.25,17.25 C15.075,17.25 15.75,16.575 15.75,15.75 L15.75,5.25 C15.75,4.425 15.075,3.75 14.25,3.75 Z M14.25,15.75 L6,15.75 L6,5.25 L14.25,5.25 L14.25,15.75 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </button>
            <a v-if="feature['email'] && isMobile()" :href="`mailto:${feature['email']}`">
                <svg
                    width="20px"
                    height="16px"
                    viewBox="0 0 20 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="mail_outline_black_24dp"
                            transform="translate(-2.000000, -4.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,18 L4,18 L4,8 L12,13 L20,8 L20,18 Z M12,11 L4,6 L20,6 L12,11 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                <span>{{ feature['email'] }}</span>
            </a>
            <button
                v-if="feature['tel'] && !isMobile()"
                type="button"
                @click="copyTel"
                v-tippy="{ placement: 'right', delay: 0 }"
                content="Kopieer"
                aria-label="Kopieer telefoonnummer"
            >
                <svg
                    width="20px"
                    height="18px"
                    viewBox="0 0 20 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path
                            d="M4.54,2 C4.6,2.89 4.75,3.76 4.99,4.59 L3.79,5.79 C3.38,4.59 3.12,3.32 3.03,2 L4.54,2 M14.4,14.02 C15.25,14.26 16.12,14.41 17,14.47 L17,15.96 C15.68,15.87 14.41,15.61 13.2,15.21 L14.4,14.02 M5.5,0 L2,0 C1.45,0 1,0.45 1,1 C1,10.39 8.61,18 18,18 C18.55,18 19,17.55 19,17 L19,13.51 C19,12.96 18.55,12.51 18,12.51 C16.76,12.51 15.55,12.31 14.43,11.94 C14.33,11.9 14.22,11.89 14.12,11.89 C13.86,11.89 13.61,11.99 13.41,12.18 L11.21,14.38 C8.38,12.93 6.06,10.62 4.62,7.79 L6.82,5.59 C7.1,5.31 7.18,4.92 7.07,4.57 C6.7,3.45 6.5,2.25 6.5,1 C6.5,0.45 6.05,0 5.5,0 Z"
                            id="Shape"
                            fill="currentColor"
                            fill-rule="nonzero"
                        ></path>
                    </g>
                </svg>
                <span>{{ feature['tel'] }}</span>
                <svg
                    width="15px"
                    height="18px"
                    viewBox="0 0 15 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="content_copy_black_18dp"
                            transform="translate(-1.000000, 0.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,0.75 L3,0.75 C2.175,0.75 1.5,1.425 1.5,2.25 L1.5,12.75 L3,12.75 L3,2.25 L12,2.25 L12,0.75 Z M14.25,3.75 L6,3.75 C5.175,3.75 4.5,4.425 4.5,5.25 L4.5,15.75 C4.5,16.575 5.175,17.25 6,17.25 L14.25,17.25 C15.075,17.25 15.75,16.575 15.75,15.75 L15.75,5.25 C15.75,4.425 15.075,3.75 14.25,3.75 Z M14.25,15.75 L6,15.75 L6,5.25 L14.25,5.25 L14.25,15.75 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </button>
            <a v-if="feature['tel'] && isMobile()" :href="`tel:${feature['tel']}`">
                <svg
                    width="20px"
                    height="18px"
                    viewBox="0 0 20 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path
                            d="M4.54,2 C4.6,2.89 4.75,3.76 4.99,4.59 L3.79,5.79 C3.38,4.59 3.12,3.32 3.03,2 L4.54,2 M14.4,14.02 C15.25,14.26 16.12,14.41 17,14.47 L17,15.96 C15.68,15.87 14.41,15.61 13.2,15.21 L14.4,14.02 M5.5,0 L2,0 C1.45,0 1,0.45 1,1 C1,10.39 8.61,18 18,18 C18.55,18 19,17.55 19,17 L19,13.51 C19,12.96 18.55,12.51 18,12.51 C16.76,12.51 15.55,12.31 14.43,11.94 C14.33,11.9 14.22,11.89 14.12,11.89 C13.86,11.89 13.61,11.99 13.41,12.18 L11.21,14.38 C8.38,12.93 6.06,10.62 4.62,7.79 L6.82,5.59 C7.1,5.31 7.18,4.92 7.07,4.57 C6.7,3.45 6.5,2.25 6.5,1 C6.5,0.45 6.05,0 5.5,0 Z"
                            id="Shape"
                            fill="currentColor"
                            fill-rule="nonzero"
                        ></path>
                    </g>
                </svg>
                <span>{{ feature['tel'] }}</span>
            </a>
        </div>

        <div class="details">
            <dl>
                <dt>Schoolbestuur</dt>
                <dd><markdown :source="feature['schoolbestuur']" /></dd>

                <dt>Onderwijsvorm</dt>
                <dd>{{ feature['onderwijsvorm'] }}</dd>

                <dt>Identiteit</dt>
                <dd>{{ feature['identiteit'] }}</dd>

                <dt v-if="feature['overige_informatie']">Overige informatie</dt>
                <dd v-if="feature['overige_informatie']">
                    <markdown :source="feature['overige_informatie']" />
                </dd>
            </dl>
        </div>
    </Panel>
</template>

<script>
import Markdown from './Markdown'
import Panel from './Panel.vue'
import Button from './Button.vue'

export default {
    name: 'DetailPanel',
    components: {
        Panel,
        Button,
        Markdown,
    },
    props: {
        feature: Object,
    },
    data() {
        return {
            copied: null,
        }
    },
    methods: {
        closePanel() {
            this.$emit('close-panel')
        },
        copyEmail() {
            navigator.clipboard
                .writeText(this.feature['email'])
                .then(() => {
                    // TODO: trigger a manual tippy with "Copied!"
                    this.copied = 'email'
                    setTimeout(() => (this.copied = null), 3000)
                })
                .catch((error) => console.error(error))
        },
        copyTel() {
            navigator.clipboard
                .writeText(this.feature['tel'])
                .then(() => {
                    // TODO: trigger a manual tippy with "Copied!"
                    this.copied = 'tel'
                    setTimeout(() => (this.copied = null), 3000)
                })
                .catch(() => console.error(error))
        },
        isMobile: function () {
            let check = false
            ;(function (a) {
                if (
                    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                        a
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        a.substr(0, 4)
                    )
                )
                    check = true
            })(navigator.userAgent || navigator.vendor || window.opera)
            return check
        },
    },
}
</script>

<style scoped>
.details {
    padding: var(--padding-screen);
}

.details ::v-deep(a) {
    color: var(--color-primary);
    text-decoration: none;
}

.details ::v-deep(a:hover),
.details ::v-deep(a:active) {
    text-decoration: underline;
}

h3 {
    margin: 0;
    font-size: var(--font-size-large);
}

p {
    margin: 16px 0 0;
}

dl {
    margin: 0;
}

dt {
    display: block;
    margin: 0 0 4px;
    font-weight: var(--font-weight-bold);
}

dd {
    margin: 0 0 16px;
}

a {
    color: var(--color-primary);
}

.type {
    display: flex;
    align-items: center;
    font-size: var(--font-size-small);
    color: var(--color-text-grey);
}

.type img {
    margin-left: 5px;
}

.address {
    margin-top: 2px;
    font-size: var(--font-size-small);
}

.expand-icon {
    margin: 0 auto;
}

@media (min-width: 576px) {
    .expand-icon {
        visibility: hidden;
    }
}

.links {
    padding: 8px 0;
    border-top: 1px solid var(--color-grey-30);
    border-bottom: 1px solid var(--color-grey-30);
    font-size: var(--font-size-small);
}

.links > * {
    box-sizing: border-box;
    min-height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px var(--padding-screen) 9px;
    text-decoration: none;
    border: none;
    background: transparent;
}

.links > a {
    color: var(--color-primary);
}

.links > button:not([disabled]):hover {
    background: var(--color-hover);
}

.links > button:not([disabled]):active {
    background: var(--color-active);
}

.links a:hover,
.links a:active {
    text-decoration: underline;
}

.links svg {
    flex-shrink: 0;
}

.links svg:first-child {
    margin-right: 12px;
    color: var(--color-primary);
}

.links svg:last-child {
    color: var(--color-icon-grey);
}

.links svg:last-child:not(:first-child) {
    padding-left: 8px;
    margin-left: auto;
}
</style>
